import {Fragment, memo, useContext, useState} from "react";
import MaterialButton from "@mui/material/Button";
import {useHistory} from "react-router-dom";

import Menu from "../../UI/Menu/Menu";

import AuthContext from "../../../context/AuthContext";
import {t} from "../../../functions/i18n";

import Avatar from "@mui/material/Avatar";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";

import Icon from "../../UI/Icon/Icon";
import PeopleIcon from "@mui/icons-material/People";
import SettingsIcon from "@mui/icons-material/Settings";

import styles from "./NavigationItem.module.scss";

import menuStyles from "../../UI/Menu/Menu.module.scss";
import Popup from "../../UI/Popup/Popup";
import RowMusicShelf from "../../RowMusicShelf/RowMusicShelf/RowMusicShelf";

const settingsMenuPaperProps = {
  elevation: 0,
  sx: {
    "overflow": "visible",
    "filter": "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    "mt": 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "& .MuiMenu-list": {
      bgcolor: "#212121 !important",
      color: "#fff !important",
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      left: "82%",
      width: 12,
      height: 12,
      bgcolor: "rgba(15, 15, 15, 0.7)",
      transform: "translateX(-50%) translateY(-50%) rotate(45deg)",
      zIndex: 0,
      borderTop: "1px solid rgba(255, 255, 255, 0.1)",
      borderLeft: "1px solid rgba(255, 255, 255, 0.1)",
      backdropFilter: "blur(40px)",
    },
  },
};

function SettingButton() {
  const AuthCtx = useContext(AuthContext);
  const history = useHistory();
  const {logout, username, avatarUrl, language} = AuthCtx;
  const [isContributorsOpen, setIsContributorsOpen] = useState(false);

  const classes = `${styles["nav-btn"]} ${styles["nav-btn-settings"]}`;

  const content = (
    <MaterialButton
      color="inherit"
      title={t(language, "settings")}
      className={classes}
    >
      <Avatar 
        src={avatarUrl || undefined} 
        sx={{width: 32, height: 32}}
      >
        {typeof username === "string" ? username.charAt(0).toUpperCase() : "X"}
      </Avatar>
    </MaterialButton>
  );

  const contributorsContent = (
    <ul style={{listStyle: "none", padding: 0, margin: 0}}>
      <RowMusicShelf
        rawData={true}
        type="contributor"
        data={{
          title: "Philip Lima",
          thumbnail: "https://philiplima.netlify.app/assets/img/phil.jpg",
        }}
        github="https://github.com/philipxlima"
        linkedIn="https://www.linkedin.com/in/philipx/"
        url="https://philiplima.netlify.app"
      />
    </ul>
  );

  const menuItems = [
    <MenuItem key="X" className="link-small overflow-clip mg-r-1">
      <Avatar
        src={avatarUrl || undefined}
        sx={{
          width: 32,
          height: 32,
          bgcolor: "#fafafa80 !important",
          color: "#000 !important",
        }}>
        {typeof username === "string" ? username.charAt(0).toUpperCase() : "X"}
      </Avatar>
      <span className="mg-l-1 overflow-clip">{username || "User"}</span>
    </MenuItem>,

    <MenuItem
      key="W"
      onClick={(e) => {
        setIsContributorsOpen(true);
      }}
      className={`text-small ${menuStyles["menu-item"]} ${menuStyles["menu-item-contributors"]}`}>
      <ListItemIcon>
        <PeopleIcon
          className={menuStyles["menu-item-icon"]}
        />
      </ListItemIcon>
      <span style={{marginLeft: "12px"}}>{t(language, "contributors")}</span>
    </MenuItem>,

    <Divider key="Y" />,
    <MenuItem
      key="SETTINGS"
      onClick={() => history.push("/settings")}
      className={`text-small ${menuStyles["menu-item"]}`}>
      <ListItemIcon>
        <SettingsIcon
          className={menuStyles["menu-item-icon"]}
        />
      </ListItemIcon>
      <span>{t(language, "settings")}</span>
    </MenuItem>,
    <MenuItem
      key="Z"
      onClick={logout}
      className={`text-small ${menuStyles["menu-item"]}`}>
      <ListItemIcon>
        <Icon svg="logout" alt="" className={menuStyles["menu-item-icon"]} />
      </ListItemIcon>
      <span>{t(language, "logout")}</span>
    </MenuItem>,
  ];

  return (
    <Fragment>
      <Menu
        fullSpace
        contentContainerClassName="full-hw flex-align"
        className={styles["setting-menu"]}
        PaperProps={settingsMenuPaperProps}
        anchorOrigin={{vertical: "bottom", horizontal: "center"}}
        transformOrigin={{vertical: "top", horizontal: "center"}}
        triggerContent={content}
        menuItems={menuItems}
      />
      
      {isContributorsOpen && (
        <Popup
          notCloseable={true}
          title={t(language, "contributors")}
          content={contributorsContent}
          onClose={() => setIsContributorsOpen(false)}
        />
      )}
    </Fragment>
  );
}

export default memo(SettingButton);

